document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector('.header');
  const searchDrawer = document.querySelector('#SearchDrawer');

  function updateHeaderBottomVar() {
    if (header) {
      const headerBottom = header.getBoundingClientRect().bottom;
      document.documentElement.style.setProperty('--header-bottom', `${headerBottom}px`);
      if (searchDrawer) {
        searchDrawer.style.top = `${headerBottom}px`;
      }
    }
  }

  updateHeaderBottomVar();
  window.addEventListener('scroll', updateHeaderBottomVar);
  window.addEventListener('resize', updateHeaderBottomVar);

  const fakeInput = document.getElementById('headerSearch');
  const originalIcon = document.querySelector('.search-drawer-button');
  const originalInput = document.querySelector('.search__input');
});
